import { useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import RequestForm from './components/RequestForm';
import Gallery from './components/pages/Gallery';
import FAQ from './components/pages/FAQ';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname]);

  const handleStartRequest = () => {
    navigate('/form');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleNavigate = (view: string) => {
    if (view === '/') {
      navigate('/');
    } else {
      navigate(`/${view}`);
    }
  };

  // Get current view from pathname
  const getCurrentView = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/form') return 'form';
    if (path === '/gallery') return 'gallery';
    if (path === '/faq') return 'faq';
    // if (path === '/contact') return 'contact';
    return 'home';
  };

  return (
    <div className="App">
      <Navbar currentView={getCurrentView()} onNavigate={handleNavigate} />
      <Routes>
        <Route path="/" element={<HomePage onStartRequest={handleStartRequest} />} />
        <Route path="/form" element={<RequestForm onBackToHome={handleBackToHome} />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/faq" element={<FAQ />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
